const validationConfiguration = {
  validation_configuration: "Validation Configuration",
  validation_configuration_description:
    "Configurable validation rules for entity references in invoice lines",
  save: "Save",
  saved_successfully: "Successfully saved",
  po_based_invoice: "PO based Invoice",
  delivery_note_based_invoice: "Delivery Note based Invoice",
  validatePurchaseOrderLineId: "PO Line Items is required",
  validatePurchaseOrderLineId_description:
    "Purchase order line id must be present on each item line",
  validateDeliveryNoteLineId: "DN Line Items is required",
  validateDeliveryNoteLineId_description:
    "Delivery note line id must be present on each item line",
  validateGRNLineId: "GRN Line Items is required",
  validateGRNLineId_description:
    "Goods received note line id must be present on each item line",
  validateItemLineTaxId: "Item Line Tax is required",
  validateItemLineTaxId_description: "Tax id must be present on each item line",
  validateTaxLineTaxId: "Tax Line Tax is required",
  validateTaxLineTaxId_description: "Tax id must be present on each tax line",
  entity_validation: "Entity Validation",
  enableCompanyEntityValidation: "Company Entity Validation",
  enableCompanyEntityValidation_description:
    "Validate the company entity reference on the document",
  enableSupplierEntityValidation: "Supplier Entity Validation",
  enableSupplierEntityValidation_description:
    "Validate the supplier entity reference on the document",
  enableCustomerEntityValidation: "Customer Entity Validation",
  enableCustomerEntityValidation_description:
    "Validate the customer entity reference on the document",
  validation_configuration_company_entity_validation_required:
    "Company entity validation is required",
};

export default validationConfiguration;
